module.exports = __webpack_public_path__ + "static/media/infoJumbo1.ad984b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/nordlock/images/infoJumbo1.jpg
// module id = 549
// module chunks = 0